import login from './login.json'
import resetPassword from './resetPassword.json'
import page404 from './404.json'
export default {
  login,
  resetPassword,
  page404
}
